import {
  Component,
  afterNextRender,
  computed,
  inject,
  OnInit,
  ChangeDetectionStrategy,
  signal,
} from '@angular/core';
import { ThemeService } from '@awo-care/utils';
import { NavbarComponent } from './core/components/navbar.component';
import { environment } from '@awo-care/shared-auth';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { UserService } from './core/services/user.service';
import {
  CookieConsentComponentWrapper,
  FooterComponent,
  skipToMainContent,
} from '@awo-care/shared-ui';
import { LanguageService } from '@awo-care/shared-core';
import { versionCustomer } from 'package.json';

@Component({
  selector: 'app-root',
  imports: [
    NavbarComponent,
    RouterOutlet,
    CookieConsentComponentWrapper,
    FooterComponent,
  ],
  host: { class: 'awo-redesign' },
  template: `
    @if(!environment.disableCookieBanner) {
      <lib-care-cookie-consent-wrapper />
    }
    @if(userService.isInitialized()) {
    @if(!bareLayout()) {
    <app-navbar />
    }
    <main id="main-content" role="main" tabindex="-1">
      <router-outlet />
    </main>
    @if(!bareLayout()) {
    <lib-footer [showWholeFooter]="true" [websiteUrl]="environment.appUrls.website" />
    }
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private themeService = inject(ThemeService);
  private router = inject(Router);
  userService = inject(UserService);
  languageService = inject(LanguageService);
  environment = environment;

  /**
   * Die Kündigungs- und die Widerrufsseite laufen ohne Seitenkopf und ohne
   * Fuss (#1120): Beide Bestätigungsseiten dürfen ausser dem Formular und der
   * Bestätigungsschaltfläche nichts enthalten, was von der Erklärung wegführt
   * (§ 312k Abs. 2 BGB, BGH I ZR 200/25).
   */
  private static readonly BARE_ROUTES = ['/kuendigen', '/widerruf'];

  private readonly currentUrl = signal<string>('');

  readonly bareLayout = computed(() =>
    AppComponent.BARE_ROUTES.some((path) => this.currentUrl().startsWith(path))
  );

  constructor() {
    // Der Skip-Link steht in index.html, außerhalb von Angular (#1209).
    afterNextRender(() =>
      document.querySelector('a.skip-link')?.addEventListener('click', skipToMainContent)
    );
    this.currentUrl.set(this.router.url);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => this.currentUrl.set(this.router.url));

    console.log(
      `%c AWO Care Customer UI %cv${versionCustomer}`,
      'background: #1976d2; color: white; padding: 2px 6px; font-weight: bold;',
      'background: #424242; color: white; padding: 2px 6px;'
    );
    this.themeService.initializeTheme('brand-theme');
    if (!environment.production) {
      const splashScreen = document.getElementById('splash-screen');
      splashScreen?.remove();
    }
  }

  ngOnInit() {
    setTimeout(() => {
      const splashScreen = document.getElementById('splash-screen');
      if (splashScreen) {
        splashScreen.classList.add('hide');
        setTimeout(() => splashScreen.remove(), 500);
      }
    }, 500);
  }
}
